// AI素养学院页面
import React, { useState, useEffect, useRef } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import MD5 from 'js-md5'
import styles from './AISYZX.module.css'
import { Button, Flex, message, Modal } from 'antd'
import HeaderBar from './HeaderBar'
import bannerImg from './banner.jpg'
import classNames from 'classnames'
import { getVideoPlayerAuthRequest } from './AISYZXApi'
export default function AISYZX(props) {
  //   const count = useSelector(selectCount);
  const dispatch = useDispatch()
  const [messageApi, contextHolder] = message.useMessage()
  const [showVideo, setShowVideo] = useState(false)

  // const incrementValue = Number(incrementAmount) || 0;

  useEffect(() => {
    // 在这里执行你的组件挂载后的逻辑
    // 这里可以返回一个清理函数，它会在组件卸载前执行
    return () => {
      // console.log('组件即将卸载');
    }
  }, []) // 空数组意味着这个 effect 只会在组件挂载时执行一次

  function createBotMethod(params) {
    props.jumpToCreateBot(31)
  }

  return (
    <div
      className={styles.background}
      //  onKeyDown={keyPress}
    >
      {contextHolder}
      <HeaderBar
        // searchInputChange = {searchInputChange}
        createBot={createBotMethod}
      />
      <img className={styles.bannerImg} src={bannerImg} />
      <div className={styles.appBoxs}>
        <div className={styles.leftApp}>
          <img className={classNames(styles.appIcon, styles.leftImgBg)} />
          <div className={styles.appTitle}>
            AIWorld 是聚焦人工智能素养课程的教学工具平台，提供体系化的 AI
            知识与技能培养方案。
          </div>
          <Button
            style={{
              borderRadius: '8px',
              height: '30px',
              width: '110px',
              marginTop: '40px',
            }}
            type="primary"
            htmlType="submit"
            block
            onClick={(e) => {
              window.open('https://ai.gamepku.com/aiworld/index.html')
            }}
          >
            进入AIWorld
          </Button>
        </div>
        <div className={styles.rightApp}>
          <img className={classNames(styles.appIcon, styles.rightImgBg)} />
          <div className={styles.appTitle}>
            专注⾃我觉知与驱动⼒
            <br />
            实现终⾝学习能⼒提升
          </div>
          <Button
            style={{
              borderRadius: '8px',
              height: '30px',
              width: '110px',
              marginTop: '40px',
            }}
            type="primary"
            block
            onClick={(e) => {
              window.open('https://cloud.iquizoo.com/login')
            }}
          >
            进入脑智世界
          </Button>
        </div>
      </div>
    </div>
  )
}
